module.exports = __webpack_public_path__ + "img/mypage-chara.86a43529.png";